import { 
    ADD_ALL_VARIANT_PRICING, ADD_ALL_VARIANT_PRICING_ERROR, ADD_ALL_VARIANT_PRICING_SUCCESS, 
    ADD_CAR_VARIANT_FAIL, ADD_CAR_VARIANT_SUCCESS, DELETE_ALL_CAR_VARIANT_SUCCESS, 
    DELETE_CAR_VARIANT_FAIL, DELETE_CAR_VARIANT_PRICING, DELETE_CAR_VARIANT_PRICING_FAIL, 
    DELETE_CAR_VARIANT_PRICING_SUCCESS, DELETE_CAR_VARIANT_SUCCESS, GET_CAR_VARIANTS_FAIL, 
    GET_CAR_VARIANTS_SUCCESS, GET_CAR_VARIANT_PRICING, GET_CAR_VARIANT_PRICING_FAIL, 
    GET_CAR_VARIANT_PRICING_SUCCESS, GET_COUNTRIES_LIST_SUCCESS, UPDATE_CAR_VARIANT_FAIL, 
    UPDATE_CAR_VARIANT_SUCCESS, GET_CAR_VARIANTS_PAGINATED, GET_CAR_VARIANTS_PAGINATED_SUCCESS, 
    GET_CAR_VARIANTS_PAGINATED_FAIL, LOAD_MORE_CAR_VARIANTS, LOAD_MORE_CAR_VARIANTS_SUCCESS, 
    LOAD_MORE_CAR_VARIANTS_FAIL, RESET_CAR_VARIANTS_PAGINATION,
    SEARCH_CAR_VARIANTS, SEARCH_CAR_VARIANTS_SUCCESS, SEARCH_CAR_VARIANTS_FAIL,
    SEARCH_CAR_VARIANTS_ALL, SEARCH_CAR_VARIANTS_ALL_SUCCESS, SEARCH_CAR_VARIANTS_ALL_FAIL,
    SET_CAR_VARIANTS_SEARCH_FILTERS, CLEAR_CAR_VARIANTS_SEARCH_FILTERS
} from "./actionTypes";

const INIT_STATE = {
    carVariants: [],
    countries: [],
    error: {},
    carVariantPricing: [],
    carVariantSaveLoader: false,
    carVariantPriceLoader: false,
    // Pagination state
    paginatedCarVariants: [],
    isLoading: false,
    isLoadingMore: false,
    isSearching: false,
    // Server pagination metadata
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 50,
        hasNextPage: false,
        hasPrevPage: false,
        nextPage: null,
        prevPage: null,
        recordsOnCurrentPage: 0
    },
    // ✅ NEW: Search filters
    searchFilters: {
        search: '',
        modelId: '',
        brandId: '',
        sortBy: 'updatedAt',
        sortOrder: 'desc'
    },
    // ✅ NEW: Search results
    searchResults: [],
    searchPagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 50,
        hasNextPage: false,
        hasPrevPage: false,
        nextPage: null,
        prevPage: null,
        recordsOnCurrentPage: 0
    },
};

const carVariant = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CAR_VARIANTS_SUCCESS:
            return {
                ...state,
                carVariants: action.payload,
            };

        case GET_CAR_VARIANTS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case ADD_CAR_VARIANT_SUCCESS:
            return {
                ...state,
                carVariants: [...state.carVariants, action.payload.carVariant],
            };

        case ADD_CAR_VARIANT_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_CAR_VARIANT_SUCCESS:
            return {
                ...state,
                carVariants: state.carVariants.map(carVariant =>
                    carVariant._id.toString() === action.payload._id.toString()
                        ? { carVariant, ...action.payload }
                        : carVariant
                ),
            };

        case UPDATE_CAR_VARIANT_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_CAR_VARIANT_SUCCESS:
            return {
                ...state,
                carVariants: state.carVariants.filter(
                    carVariant => carVariant._id.toString() !== action.payload._id.toString()
                ),
            };

        case DELETE_CAR_VARIANT_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_ALL_CAR_VARIANT_SUCCESS:
            return {
                ...state,
                carVariants: []
            }
        case ADD_ALL_VARIANT_PRICING:
            return {
                ...state,
                carVariantSaveLoader: true
            };
        case ADD_ALL_VARIANT_PRICING_SUCCESS: 
        return {
            ...state,
            carVariantPriceLoader: false
        };
        case ADD_ALL_VARIANT_PRICING_ERROR: 
        return {
            ...state,
            carVariantPriceLoader: false
        };
        case GET_CAR_VARIANT_PRICING:
            return {
                ...state,
                carVariantPriceLoader: true
            };
        case GET_CAR_VARIANT_PRICING_SUCCESS:
            return {
                ...state,
                carVariantPricing: action.payload,
                carVariantPriceLoader: false
            };
        case DELETE_CAR_VARIANT_PRICING_SUCCESS:
            return {
                ...state,
                carVariantPricing: []
            };
        case DELETE_CAR_VARIANT_PRICING_FAIL:
            return {
                ...state,
                carVariantPricing: state.carVariantPricing
            };

        case GET_CAR_VARIANT_PRICING_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case GET_COUNTRIES_LIST_SUCCESS:
            return {
                ...state,
                countries: action.payload
            }

        // Paginated Car Variants Cases
        case GET_CAR_VARIANTS_PAGINATED:
            return {
                ...state,
                isLoading: true,
                error: {}
            };

        case GET_CAR_VARIANTS_PAGINATED_SUCCESS:
            return {
                ...state,
                paginatedCarVariants: action.payload.data,
                pagination: action.payload.pagination,
                isLoading: false,
                error: {}
            };

        case GET_CAR_VARIANTS_PAGINATED_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        // Load More Car Variants Cases
        case LOAD_MORE_CAR_VARIANTS:
            return {
                ...state,
                isLoadingMore: true,
                error: {}
            };

        case LOAD_MORE_CAR_VARIANTS_SUCCESS:
            return {
                ...state,
                paginatedCarVariants: [...state.paginatedCarVariants, ...action.payload.data],
                pagination: action.payload.pagination,
                isLoadingMore: false,
                error: {}
            };

        case LOAD_MORE_CAR_VARIANTS_FAIL:
            return {
                ...state,
                isLoadingMore: false,
                error: action.payload
            };

        // Reset Pagination
        case RESET_CAR_VARIANTS_PAGINATION:
            return {
                ...state,
                paginatedCarVariants: [],
                isLoading: false,
                isLoadingMore: false,
                pagination: {
                    currentPage: 1,
                    totalPages: 1,
                    totalRecords: 0,
                    recordsPerPage: 50,
                    hasNextPage: false,
                    hasPrevPage: false,
                    nextPage: null,
                    prevPage: null,
                    recordsOnCurrentPage: 0
                },
                error: {}
            };

        // ✅ NEW: Search Car Variants (paginated)
        case SEARCH_CAR_VARIANTS:
            return {
                ...state,
                isSearching: true,
                isLoading: true,
                error: {}
            };

        case SEARCH_CAR_VARIANTS_SUCCESS:
            return {
                ...state,
                searchResults: action.payload.data,
                paginatedCarVariants: action.payload.data,
                searchPagination: action.payload.pagination,
                pagination: action.payload.pagination,
                isSearching: false,
                isLoading: false,
                error: {}
            };

        case SEARCH_CAR_VARIANTS_FAIL:
            return {
                ...state,
                isSearching: false,
                isLoading: false,
                error: action.payload
            };

        // ✅ NEW: Search Car Variants (all - no pagination)
        case SEARCH_CAR_VARIANTS_ALL:
            return {
                ...state,
                isSearching: true,
                isLoading: true,
                error: {}
            };

        case SEARCH_CAR_VARIANTS_ALL_SUCCESS:
            return {
                ...state,
                searchResults: action.payload,
                carVariants: action.payload,
                isSearching: false,
                isLoading: false,
                error: {}
            };

        case SEARCH_CAR_VARIANTS_ALL_FAIL:
            return {
                ...state,
                isSearching: false,
                isLoading: false,
                error: action.payload
            };

        // ✅ NEW: Set/Clear search filters
        case SET_CAR_VARIANTS_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...state.searchFilters,
                    ...action.payload
                }
            };

        case CLEAR_CAR_VARIANTS_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    search: '',
                    modelId: '',
                    brandId: '',
                    sortBy: 'updatedAt',
                    sortOrder: 'desc'
                },
                searchResults: [],
                searchPagination: {
                    currentPage: 1,
                    totalPages: 1,
                    totalRecords: 0,
                    recordsPerPage: 50,
                    hasNextPage: false,
                    hasPrevPage: false,
                    nextPage: null,
                    prevPage: null,
                    recordsOnCurrentPage: 0
                }
            };

        default:
            return state;
    }
};

export default carVariant;
